import React from "react";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import Term from "../components/term";
import { useState } from "react";
import NonLoginHeader from "../components/header/NonLoginHeader";
import MobileHeader from "../components/header/MobileHeader";

Termsofuse.propTypes = {};

function Termsofuse(props) {
  const [isShowMobile, setShowMobile] = useState(false);



  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  return (
    <>

      <MobileHeader handleMobile={handleMobile} />
      <NonLoginHeader clname="" handleMobile={handleMobile} />
      {/* <Breadcrumb title="Term Of Use" /> */}
      <div className="pt-70">
        <Term />
        <Footer />
        <Gotop />
      </div>
    </>
  );
}

export default Termsofuse;
